import { render } from "./index.vue?vue&type=template&id=cc1ded5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cc1ded5e&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\qfy-all\\qfy-oms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1ded5e"]])

export default __exports__